import React from 'react';
import { Phone } from 'lucide-react';
import { Button } from './ui/button';
import { COMPANY, HERO_STATS } from '../mock';

const Hero = () => {
  return (
    <section id="home" className="relative pt-28">
      <div
        className="relative min-h-[640px] flex items-center bg-cover bg-center"
        style={{
          backgroundImage:
            "linear-gradient(rgba(13,61,94,0.72), rgba(13,61,94,0.72)), url('/images/truck2.jpeg')",
        }}
      >
        <div className="max-w-7xl mx-auto px-4 lg:px-8 w-full py-16">
          <div className="max-w-2xl text-white">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.1] tracking-tight">
              24/7 Refrigerated Transport in Perth
            </h1>
            <p className="mt-6 text-lg text-slate-100/90 leading-relaxed max-w-xl">
              Reliable cold-chain delivery for temperature-sensitive goods across
              Perth and Western Australia. Same-day, emergency, and scheduled
              services — available around the clock.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <a href={`tel:${COMPANY.phoneRaw}`}>
                <Button
                  size="lg"
                  className="bg-white text-[#0d3d5e] hover:bg-slate-100 rounded-md h-12 px-6 font-semibold"
                >
                  <Phone className="w-5 h-5 mr-2" /> Call Now
                </Button>
              </a>
              <a href="#contact">
                <Button
                  size="lg"
                  variant="outline"
                  className="h-12 px-6 border-2 border-white text-white bg-transparent hover:bg-white hover:text-[#0d3d5e] rounded-md font-semibold"
                >
                  Request a Quote
                </Button>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-[#0d3d5e] text-white">
        <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-6 px-4 lg:px-8 py-8">
          {HERO_STATS.map((s) => (
            <div key={s.title} className="text-center">
              <div className="text-3xl md:text-4xl font-bold">{s.title}</div>
              <div className="text-sm text-slate-200 mt-1">{s.subtitle}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
